var exports = {
  "kL": "x31de4314--3698f4--container",
  "wx": "x31de4314--3698f4--header",
  "Sl": "x31de4314--3698f4--image",
  "VY": "x31de4314--3698f4--info-block",
  "Zp": "x31de4314--3698f4--layout",
  "gf": "x31de4314--3698f4--layout-params",
  "bE": "x31de4314--3698f4--layout-price",
  "M3": "x31de4314--3698f4--contacts",
  "LT": "x31de4314--3698f4--contacts-contact",
  "Le": "x31de4314--3698f4--contact-image",
  "ec": "x31de4314--3698f4--layout-title",
  "V": "x31de4314--3698f4--layout-square",
  "q9": "x31de4314--3698f4--price",
  "qy": "x31de4314--3698f4--price-per-meter",
  "lz": "x31de4314--3698f4--contact-title-type",
  "GS": "x31de4314--3698f4--contact-title-name",
  "wR": "x31de4314--3698f4--contacts-control",
  "ul": "x31de4314--3698f4--contacts-contact-title",
  "tp": "x31de4314--3698f4--table",
  "LG": "x31de4314--3698f4--table-header",
  "RP": "x31de4314--3698f4--header-cell",
  "gQ": "x31de4314--3698f4--offer-title",
  "DB": "x31de4314--3698f4--offer-title-link",
  "WD": "x31de4314--3698f4--labels",
  "nM": "x31de4314--3698f4--row",
  "Wq": "x31de4314--3698f4--description-cell",
  "e9": "x31de4314--3698f4--description-controls",
  "BI": "x31de4314--3698f4--favorite",
};

module.exports = exports;
